// extracted by mini-css-extract-plugin
export var chatHtmlText = "_q3-2";
export var chatLink = "_q3-0";
export var chatText = "_q3-1";